import { render, staticRenderFns } from "./RevenueList.vue?vue&type=template&id=1d633b06"
import script from "./RevenueList.vue?vue&type=script&lang=ts"
export * from "./RevenueList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports